import {alertValidation} from "../util/alertValidation";
import Swal from "sweetalert2";

export const accountValidation = (response) => {
    if (response.data.message !== null) {
        if (response.data.message.length > 15) {
            Swal.fire({
                title: '관리자에게 문의해주세요.',
                text: `${response.data.data !== null ? response.data.data : response.data.message}`,
                icon: 'warning',
                confirmButtonText: '확인',
            }).then(result => {
                return false
            });
        }
    }
    switch (response.data.message) {
        case "admin_002"
        :   alertValidation('수정하려는 계정 정보가 없습니다.');
            return false;
        case "admin_003"
        :   alertValidation('사용자 아이디를 입력해주세요.');
            return false;
        case "admin_004"
        :   alertValidation('비밀번호를 입력해주세요.');
            return false;
        case "admin_005"
        :   alertValidation('계정 권한을 선택해주세요.');
            return false;
        case "admin_006"
        :   alertValidation('사용자 이름을 입력해주세요.');
            return false;
        case "admin_007"
        :   alertValidation('비밀번호가 일치하지 않습니다.\n올바른 비밀번호를 입력해주세요.');
            return false;
        case "serverError"
        :   Swal.fire({
                title: '관리자에게 문의해주세요.',
                text: `${response.data.data}`,
                icon: 'warning',
                confirmButtonText: '확인',
            }).then(result => {
                return false
            });
            break;
        default :
            Swal.fire({
                text: `저장이 완료되었습니다.`,
                icon: 'success',
                confirmButtonText: '확인',
            }).then(r => {
                if (r.isConfirmed) {
                    window.location.replace('/setting/account');
                }
            });
            break;
    }
}